"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nProviderLocaleMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class I18nProviderLocaleMapper {
    toDomain(result) {
        const isLoading = lodash_1.default.get(result, "loading");
        const userLocale = lodash_1.default.get(result, "data.getUser.language");
        return {
            isLoading,
            userLocale,
        };
    }
}
exports.I18nProviderLocaleMapper = I18nProviderLocaleMapper;
